<template>
    <v-navigation-drawer class="navigation-bg" dark :disable-resize-watcher="true" :disable-route-watcher="true" :hide-overlay="true" :permanent="true" :width="250" value="true">
        <v-list>

                <v-list-tile v-for="(item, index) in items" :key="index" @click.stop="changeRoute(item.route)" v-if="checkVisible(item.admin) && typeof (item.children) == 'undefined'" :class="{ 'selected-item': isSelected(item.route) }">
                    <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
                    {{ item.text }}
                </v-list-tile>

        </v-list>
    </v-navigation-drawer>
</template>

<script>

import { mapGetters } from 'vuex'
import globalFunctions from '../../mixin'

export default {
    name: 'Navigation',
    mixins: [globalFunctions],
    data: () => ({
        items: [
            {
                icon: 'home',
                text: 'Dashboard',
                route: '/dashboard',
                admin: false
            },
            {
                icon: 'folder_open',
                text: 'Projects',
                route: '/projects',
                admin: false
            },
            {
                icon: 'description',
                text: 'Script Types',
                route: '/scripttypes',
                admin: true
            },
            {
                icon: 'menu_book',
                text: 'Libraries',
                route: '/libraries',
                admin: true
            },
            {
                icon: 'translate',
                text: 'Languages',
                route: '/languages',
                admin: true
            },
            {
                icon: 'g_translate',
                text: 'Translation',
                route: '/translations',
                admin: true
            },
            {
                icon: 'settings',
                text: 'Settings',
                route: '/settings',
                admin: true
            },
            {
                icon: 'people_outline',
                text: 'Users',
                route: '/users',
                admin: true
            },

        ]
    }),
    computed: {
        ...mapGetters(['isAuthenticated', 'miniVariant']),
    },
    methods: {
        logout () {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.replace("/login")
                })
        },
        changeRoute (route){
            if(route!=''){
                this.$router.replace(route);
            }
        },
        checkVisible ( isAdminItem ) {
            return globalFunctions.checkVisible(isAdminItem);
        },
        isSelected(route) {
            return this.$route.path === route;
        }
    },
}
</script>






